import PLANNING_WORK_MODE from './planning-work-mode/fr'

export default {
  hi: 'Bonjour',
  USER_PROFIL: "Profil de l'utilisateur",
  SIGNOUT: 'Se déconnecter',
  MYPROFIL: 'Mon profil',
  INFO: 'Paramètres du compte et plus',
  UPDATE: 'mettre à jour',
  Subscription: 'Abonnement',
  DESC: 'description',
  PLANNING_WORK_MODE,
  UNSAVED: {
    TITLE: 'Modifications non sauvegardées',
    MESSAGE: 'Vous avez des modifications non sauvegardées. Quitter cet écran les abandonnera.',
    SAVING: 'Une sauvegarde est en cours. Attendez sa confirmation avant de quitter cet écran pour éviter de perdre des modifications.',
    STAY: 'Rester',
    DISCARD: 'Quitter sans enregistrer',
  },
}
